import type { Page } from '../../types';

const diversityAndCharacteristics: Page[] = [
  {
    pageType: 'question',
    title: 'Diversity and Characteristics',
    name: 'diversity-and-characteristics',
    questions: [
      {
        questionType: 'textarea',
        title: 'Key observations',
        name: 'diversity-observations',
        hint: '',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Planned and ongoing initiatives',
        name: 'diversity-initiatives',
        hint: '',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default diversityAndCharacteristics;
